import { useEffect } from "react";
import { Link, Navigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { trpc } from "@/lib/trpc";
import { Page } from "@/components/layout/page";
import { EmptyState } from "@/components/empty-state";
import { Button } from "@/components/ui/button";

/** Forget the remembered project so "/" stops sending the user back here. */
function useClearDefaultProject() {
  const clearDefault = trpc.profile.setDefaultProject.useMutation();

  useEffect(() => {
    clearDefault.mutate({ projectId: null });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
}

export function ProjectNotFound() {
  useClearDefaultProject();

  return <Navigate to="/projects" replace />;
}

/**
 * Shown when `project.getById` answers FORBIDDEN. The API checks membership
 * before looking the project up, so this state never confirms the project
 * exists — the copy covers both cases.
 */
export function ProjectNoAccess() {
  useClearDefaultProject();

  return (
    <Page title="You don't have access to this project" maxWidth="max-w-2xl">
      <EmptyState
        icon={Lock}
        title="Ask a project owner for an invite"
        description="This project doesn't exist, or you aren't a member of it. A project owner can invite you from the project's settings."
        actions={
          <Button asChild>
            <Link to="/projects">Back to your projects</Link>
          </Button>
        }
      />
    </Page>
  );
}
